import React from 'react';
import useT from '../../utils/Translations/useT';
import SelectBoxFilter from './SelectBoxFilter';
const LPViewSelector = ({ activityNamePlural, lessonPlan, value = 'SUBJECTS_WITH_LP', ...props }) => {
    const t = useT();
    const title = t('View');
    const options = [
        {
            value: 'ALL_ACTIVE_SUBJECTS',
            name: t(`All Active #{activityNamePlural}`, {
                activityNamePlural: t(activityNamePlural),
            }),
        },
        {
            value: 'SUBJECTS_WITH_LP',
            name: t(`#{activityNamePlural} with #{lessonPlan}`, {
                activityNamePlural: t(activityNamePlural),
                lessonPlan: t(lessonPlan),
            }),
        },
    ];
    return (<SelectBoxFilter name="view" options={options} title={title} value={value} {...props}/>);
};
export default LPViewSelector;
